import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpErrorsIntercepter, HttpTokenInterceptor } from './interfceptors';
import { AdminSettingsMessagesService, AdminSettingsOrdersArchiveService, AdminSettingsInvoicesArchiveService,AdminSettingsShopsService, CartService, CommonService, InvoicesService, JwtService, OrdersService, ProductsService, ShopService, UserService } from './services';
import { AdminInvoicesService } from './services/admin-invoices.service';
import { AdminOrdersService } from './services/admin-orders.service';
import { OffersService } from './services/offers.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    ProductsService,
    UserService, 
    JwtService,
    CommonService,
    OffersService,
    ShopService,
    CartService,
    OrdersService,
    AdminOrdersService,
    InvoicesService,
    AdminInvoicesService,
    AdminSettingsShopsService,
    AdminSettingsMessagesService,
    AdminSettingsOrdersArchiveService,
    AdminSettingsInvoicesArchiveService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorsIntercepter, multi: true }
  ]
})
export class CoreModule { }
